import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import withInputValidator from './InputValidator';
import i18n from '../../../../shared/locales/no.json';

class TextArea extends React.Component {
    renderMaxlenLabel() {
        if (this.props.maxLength) {
            const charsLeft = this.props.maxLength - this.props.value.length;
            const label = `${charsLeft} ${i18n['Chars left']}`;
            return <div className="input__sub-text">{label}</div>;
        }
    }

    render() {
        const props = omit(
            this.props,
            'validationErrorMsg',
            'inputType',
            'connectValidator',
            'disconnectValidator'
        );
        return (
            <React.Fragment>
                <textarea {...props} />
                {this.renderMaxlenLabel()}
            </React.Fragment>
        );
    }
}

TextArea.propTypes = {
    maxLength: PropTypes.number,
    value: PropTypes.string,
};

TextArea.defaultProps = {
    type: 'text',
};

export default withInputValidator(TextArea);
